import { render, staticRenderFns } from "./delivery-table.vue?vue&type=template&id=ab5e80ac"
import script from "./delivery-table.vue?vue&type=script&lang=js"
export * from "./delivery-table.vue?vue&type=script&lang=js"
import style0 from "./delivery-table.vue?vue&type=style&index=0&id=ab5e80ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports